import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Flexer, Spacer } from '@ontruck/orc';
import config from 'config';
import { connect } from 'react-redux';

import { loadAlerts, flushAlerts, changeAlertStatus } from 'redux/modules/alerts/effects';
import { getAlerts } from 'redux/modules/alerts/selectors';

import { compose, lifecycle } from 'recompose';

import { StyledWrapper, StyledTitle } from './styled';
import Alert from './Alert';
import StatusChanger from './StatusChanger';

import { Loading } from 'components/Loading';

const t = {
  title: 'Alerts',
  not_reviewed_title: 'Not reviewed',
  seconds_alert: 'More than 30 minutes have passed since the order was created',
  review_action: 'Review Shipper Order',
  alerts: {
    ON_TIME: {
      title: 'Duration warning',
      subtitle: 'The time between stops seems too short.',
    },
    LOADED_TIME: {
      title: 'Loaded for too long',
      subtitle: 'The vehicle is loaded longer than necessary.',
    },
    STANDSTILL: {
      title: 'Standstill',
      subtitle: 'This order may have a standstill.',
    },
    MANIPULATION: {
      title: 'Manipulation',
      subtitle: 'The comments in this order may be asking for special manipulation.',
    },
  },
};

const actionCreators = {
  loadAlerts,
  flushAlerts,
  changeAlertStatus,
};

const enhance = compose(
  connect((state, ownProps) => {
    return {
      alerts: getAlerts(state, { id: ownProps.item.id }),
      loading: state.alerts.fetching,
      changing: state.alerts.changing,
    };
  }, actionCreators),
  lifecycle({
    componentDidMount() {
      const { loadAlerts, item } = this.props;
      loadAlerts({ item });
    },
    componentWillUnmount() {
      const { flushAlerts, item } = this.props;

      flushAlerts({ item });
    },
  })
);

const Alerts = ({ alerts, loading, changing, showTitle, item, changeAlertStatus }) => {
  const title = showTitle && (
    <Spacer>
      <StyledTitle>
        {t.title}({(alerts || []).length})
      </StyledTitle>
    </Spacer>
  );

  const isLoading = loading[item.id];

  if (isLoading) {
    return (
      <Fragment>
        {title}
        <Flexer.Parent alignItems="center" justifyContent="center" mTop="S" mBottom="S">
          <Loading />
        </Flexer.Parent>
      </Fragment>
    );
  }

  if (!alerts.length) {
    return (
      <Fragment>
        {title}
        <Flexer.Parent justifyContent="center" mTop="S" mBottom="S">
          No alerts
        </Flexer.Parent>
      </Fragment>
    );
  }

  return (
    !isLoading &&
    alerts && (
      <Fragment>
        {title}
        <StyledWrapper p="S" flexDirection="column">
          {alerts.map((alert, key) => (
            <Alert
              first={key === 0}
              title={(t.alerts[alert.alert_type] || {}).title || alert.alert_type}
              subtitle={(t.alerts[alert.alert_type] || {}).subtitle}
              loading={loading}
              changing={changing}
              actionChildren={
                <StatusChanger
                  status={alert.status}
                  alertUrl={`${config.API_URL}mercury/shipper_orders/${item.id}/alerts/${alert.id}/`}
                  changeAlertStatus={changeAlertStatus}
                  itemId={item.id}
                />
              }
            />
          ))}
        </StyledWrapper>
      </Fragment>
    )
  );
};

Alerts.propTypes = {
  loading: PropTypes.bool.isRequired,
  alerts: PropTypes.array,
  changing: PropTypes.bool,
  showTitle: PropTypes.bool,
  item: PropTypes.shape({}),
  changeAlertStatus: PropTypes.func,
};

Alerts.defaultProps = {
  alerts: [],
};

export default enhance(Alerts);
